import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-assessment-slider-right',
    templateUrl: './assessment-slider-right.component.html',
    styleUrls: ['./assessment-slider-right.component.scss'],
    standalone: false
})
export class AssessmentSliderRightComponent implements OnInit, OnChanges {
  @Input() score!: number;

  fillWidth: string = '0%';

  constructor() { }

  ngOnInit(): void {
    this.updateFillWidth();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['score']) {
      this.updateFillWidth();
    }
  }

  updateFillWidth(): void {
    // Calculate percentage width from score (0-5 range)
    if (this.score != null && !isNaN(this.score)) {
      const percentage = (this.score / 5) * 100;
      this.fillWidth = `${percentage}%`;
    } else {
      this.fillWidth = '0%';
    }
  }
}

